import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createApi } from "utils/@reduxjs/toolkit";
import { ManageCardsState } from "./types";
import { endpoints, formatErrors, baseQuery } from "utils/api/endpoints";

export const initialState: ManageCardsState = {};

export const slice = createSlice({
  name: "manageCards",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: "manageCardsApi",
  baseQuery,
  endpoints: (build) => ({
    createCard: build.mutation<any, any>({
      query: (body) => {
        return {
          ...endpoints.createCard,
          body,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    getCards: build.query<any, any>({
      query: (params) => {
        return {
          url: endpoints.getCards.url + "/" + params.customerId,
          method: endpoints.getCards.method,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    deleteCard: build.mutation<any, any>({
      query: (params) => {
        return {
          url: endpoints.deleteCard.url + "/" + params.cardId,
          method: endpoints.deleteCard.method,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
  }),
});

export const { actions: Actions } = slice;

export const useSlice = () => {
  return { ...api, actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
